import { KeyboardEventHandler, useEffect, useRef, useState } from 'react';
import { ChevronArrowDown, ChevronArrowUp, Close } from '../../../assets/icons';
import React from 'react';
export interface OptionsProps {
    value?: string, name?: string, editable?: boolean
}
export interface ChipDropdownProps {
    options?: OptionsProps[];
    onSelect?: (options: OptionsProps[]) => void;
    placeholder?: string;
    selectedOptions?: OptionsProps[];
    disabled?: boolean;
    disableFirstChipRemove?: boolean; 
}
const ChipsDropdown: React.FC<ChipDropdownProps> = ({
    options,
    onSelect = (options: OptionsProps[]) => { },
    placeholder,
    selectedOptions,
    disabled = false,
     disableFirstChipRemove = false,
}) => {
    const [dropdownActive, setDropdownActive] = useState(false);
    const [selectedItems, setSelectedItems] = useState([] as OptionsProps[]);
    const [filteredOptions, setFilteredOptions] = useState([] as OptionsProps[]);
    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setDropdownActive(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setSelectedItems(selectedOptions || []);
        if (selectedOptions?.length && options?.length) {
            setFilteredOptions(options.filter((x => !selectedOptions.map(y => y.value).includes(x.value || ''))));
        }
    }, [options, selectedOptions]);

    const onOptionSelected = (item: OptionsProps) => {
        setSelectedItems([...selectedItems, { value: item.value, name: item.name }]);
        setFilteredOptions(filteredOptions.filter((x: OptionsProps) => x.value !== item.value));
        onSelect([...selectedItems, { value: item.value, name: item.name }]);
    }
    const onOptionRemoved = (item: OptionsProps) => {
        const newItems = selectedItems.filter((x: OptionsProps) => x.value !== item.value)
        setSelectedItems(newItems);
        setFilteredOptions(
            (options ?? []).filter(
                (x: OptionsProps) =>
                    !newItems?.map((y: OptionsProps) => y.value || "").includes(x.value || "")
            )
        );

        onSelect(newItems);
    }
    return (
        <div className="w-full flex flex-col items-center" ref={dropdownRef}>
            <div className="w-full">
                <div className="relative inline-block text-left w-full">
                    <div className="w-full">
                        <div className="my-2 p-1 flex border-gray-200 svelte-1l8159u  px-[8px] py-[4px] border-[1px] rounded-[8px] border-darkcolor-400 bg-transparent focus:outline-none text-neutral-25 hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500 w-auto">
                            <div className="flex flex-auto flex-wrap overflow-y-auto" style={{ maxHeight: '60px' }}>
                                {
                                    selectedItems?.map((item: OptionsProps) => {
                                        const matchingOption = options?.find(x => x.value === item.value);
                                        return (
                                          <div
                                            className={`flex justify-center gap-2 items-center m-1  px-2  rounded-lg white border-[2px] text-sm font-bold border-white ${
                                              item.editable === false
                                                ? "cursor-none opacity-35 pointer-events-none"
                                                : ""
                                            }`}
                                          >
                                            <div className='text-xs font-normal leading-none max-w-full flex-initial'>
                                              {matchingOption?.name}
                                            </div>
                                            <div className='flex flex-auto flex-row-reverse'>
                                              {(!disableFirstChipRemove ||
                                                selectedItems.findIndex(
                                                  (x) => x.value === item.value
                                                ) !== 0) && (
                                                <div
                                                  onClick={() =>
                                                    onOptionRemoved(item)
                                                  }
                                                >
                                                  <Close />
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        );
                                    })
                                }
                                <div className="flex-1">
                                    <input placeholder={selectedItems?.length > 0 ? '' : placeholder} onClick={() => !disabled && setDropdownActive(prev => !prev)} onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => e?.preventDefault()} className="bg-transparent p-1 px-2 appearance-none outline-none h-full w-full text-gray-800" />
                                </div>
                            </div>
                            <div className="text-gray-300 w-8 py-1 pl-2 pr-1 flex items-center border-gray-200 svelte-1l8159u">
                                <button onClick={() => !disabled && setDropdownActive(prev => !prev)} className="cursor-pointer w-6 h-6 text-gray-600 outline-none focus:outline-none">
                                    {dropdownActive ? <ChevronArrowUp /> : <ChevronArrowDown />}
                                </button>
                            </div>
                        </div>
                    </div>
                    {
                        dropdownActive && !disabled && filteredOptions?.length > 0 &&
                        < div className="absolute right-0 z-10 mt-2 w-full origin-top-right rounded-md  bg-darkcolor-700 border-[1px] border-darkcolor-400 text-sm font-normal border-solid  shadow-lg ring-1 ring-black/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in text-neutral-25">
                            <div className="flex flex-col w-full">
                                {
                                    filteredOptions.map((item: OptionsProps) =>
                                        <div onClick={() => onOptionSelected(item)} className="cursor-pointer w-full  hover:bg-darkcolor-500 hover:border-darkcolor-300">
                                            <div className="flex w-full items-center p-2 pl-2 border-transparent border-l-2 relative">
                                                <div className="w-full items-center flex">
                                                    <div className="mx-2 leading-6  ">{item.name} </div>
                                                </div>
                                            </div>
                                        </div>)
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div >
    )
}

export default ChipsDropdown;
